'use client'

import { noticeError } from '@utils/utils-analytics/notice-error'

import { useEffect } from 'react'

import { AppErrorPage } from './app-error-page'

type SegmentErrorProps = {
  boundary: string
  error: Error & { digest?: string }
  reset: () => void
}

/** Shared body for segment error.tsx files. */
export function SegmentError({ boundary, error, reset }: SegmentErrorProps) {
  useEffect(() => {
    console.error(error)
    noticeError(error, {
      boundary,
      ...(error.digest ? { digest: error.digest } : {}),
    })
  }, [boundary, error])

  return <AppErrorPage onRetry={reset} variant="server-error" />
}
